import type { DialogOptions, MessageOptions, ModalOptions } from "naive-ui";
import type { VNodeChild } from "vue";
import type { SvgName } from "@/types/svgs";
import MIcon from "@/components/GIcon/index.vue";

export function showConfirm(options: ModalOptions) {
  return new Promise((resolve, reject) => {
    window.$modal?.create({
      autoFocus: false,
      preset: "dialog",
      positiveText: "确认",
      negativeText: "取消",
      transformOrigin: "center",
      class: "w-480px!",
      positiveButtonProps: {
        type: "primary",
        size: "small",
      },
      negativeButtonProps: {
        type: "default",
        size: "small",
      },
      icon: () => {
        const iconMap = {
          error: {
            icon: "Error",
            class: "c-#FA4040",
          },
          default: {
            icon: "",
            class: "",
          },
          warning: {
            icon: "Warning",
            class: "c-#FFB33A",
          },
          info: {
            icon: "Info",
            class: "c-#3366FF",
          },
          success: {
            icon: "",
            class: "",
          },
        };
        const active = iconMap[options.type!];
        return <MIcon name={active.icon as SvgName} class={active.class} />;
      },
      onPositiveClick() {
        resolve(null);
      },
      onNegativeClick() {
        reject(new Error("点击取消"));
      },
      ...options,
    });
  });
}

export function showDialog(options: DialogOptions) {
  return new Promise((resolve, reject) => {
    const res = window.$dialog?.create({
      transformOrigin: "center",
      autoFocus: false,
      closable: true,
      positiveText: "确认",
      negativeText: "取消",
      class: "w-fit! max-w-[400px]!",
      contentClass: "pl-56px pr-20px pt-8px pb-20px text-#555555",
      titleClass: "text-normal font-600 pt-20px px-20px gap-8px",
      actionClass: "px-20px pb-20px",
      positiveButtonProps: {
        type: "primary",
        size: "small",
      },
      negativeButtonProps: {
        type: "default",
        size: "small",
      },
      icon: () => {
        const iconMap = {
          error: {
            icon: "icon-warn-fill",
            class: "c-#FA4040",
          },
          default: {
            icon: "",
            class: "",
          },
          warning: {
            icon: "icon-warn-fill",
            class: "c-#FFB33A",
          },
          info: {
            icon: "icon-warn-fill",
            class: "c-#3366FF",
          },

          success: {
            icon: "",
            class: "",
          },
        };
        const active = iconMap[options.type!];
        // return <MIcon name={active.icon as SvgName} class={active.class} />;
        return (
          <i
            class={["leading-1 text-24px iconfont ", active.icon, active.class]}
          ></i>
        );
      },
      onPositiveClick() {
        resolve(null);
      },
      onNegativeClick() {
        reject(new Error("点击取消"));
      },
      ...options,
    });
    resolve(res);
  });
}

export function showMessage(
  options: MessageOptions & { content: string | (() => VNodeChild) },
) {
  const { content, ...rest } = options;
  window.$message?.create(content, {
    ...rest,
  });
}
